import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { IoIosPaperPlane } from "react-icons/io";
import toastr from "toastr";

import { addIncidentComment } from "app/_services/ehs/ehsIncidentServices";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { withRouter } from "react-router";

const IncidentComments = ({ title = "Comments", comments = [], setComments = () => {}, type = "Investigation", match: { params: { id } }, viewOnly }) => {
    const [comment, setComment] = useState("");

    const addComment = async () => {
        if (!comment) return;

        const formData = {
            comment: comment.trim(),
            type,
        };

        const response = await addIncidentComment(formData, id);

        if (!response?.data) return toastr.error(response?.message);

        toastr.success("Comment Added.")
        setComment("");
        setComments(prev => [...prev, { ...formData, ...response.data }]);
    };

    return (
        <div className="card EHS_module_create_form p-3  pb-0 mt-2">
            <div className="simple-card-title">
                <h3 class="text-capitalize mb-1">{title}</h3>
            </div>
            <div className="chatsection">
                {comments.map((data, index) => (
                    <div key={index} className="chatscreen">
                        <h5>
                            <span className="chatname">{data.user?.firstName} {data.user?.lastName} &nbsp;</span>
                            <span className="chattime">| &nbsp;{formatDDMMYYYYbyYYYYMMDD(data.dateTime)}</span>
                        </h5>
                        <p className="mb-0">{data.comment}</p>
                    </div>
                ))}
            </div>
            {!viewOnly && <div className="form-group basic-textarea mx-n3 mb-0 mt-2">
                <textarea
                    value={comment}
                    onChange={({ target: { value } }) => setComment(value)}
                    className="form-control my-0 px-4"
                    id="comment"
                    rows="4"
                    placeholder="Add Comment Here."
                />
                <Button className="sendbtn" onClick={addComment}>
                    <IoIosPaperPlane />
                </Button>
            </div>}
        </div>
    );
};

export default withRouter(IncidentComments);
